import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';

import {
  gAPI_Property_List,
  postAPI_Create_A_Message,
  postAPI_Create_VocuherWebiste_Ingetration,
} from '../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
const GreetingCode1 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode1 = `integration-${short.generate()}-eyeCatcher`;
const GreetingCode2 = `integration-${short.generate()}-greeting`;
const EyeCatcherCode2 = `integration-${short.generate()}-eyeCatcher`;

let arr = [];
export default function AddVoucherIntregation({ visible, toggle, LoadIntegrations, imageDomain }) {
  const [property, setProperty] = useState([]);

  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Level: 'Group',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    BaseUrl: 'https://www.bookmebob.com',
    HomePageRoute: '/',
    DefaultLanguage: 'en-US',
    DefaultRuleDescription: 'Default',
    DefaultRuleNudges: [
      {
        EyeCatcher: {
          Code: EyeCatcherCode1,
          FilterTags: null,
        },
        Greeting: {
          Code: GreetingCode1,
          FilterTags: null,
        },
        DelayInMilliseconds: 5000,
      },
      {
        EyeCatcher: {
          Code: EyeCatcherCode2,
          FilterTags: null,
        },
        Greeting: {
          Code: GreetingCode2,
          FilterTags: null,
        },
        DelayInMilliseconds: 15000,
      },
    ],
    BotSettings: {
      Name: 'Bob',
      Tagline: 'Hotel Assistant',
      Colours: {
        Header: '#dfce90',
        BotBot: '#ffffff',
        BotUser: '#dfcf92',
        BotButton: '#da291c',
        BotBackground: '#e9eef4',
        HeaderText: '#4a5051',
        BotBotText: '#353f48',
        BotUserText: '#353f48',
        BotButtonText: '#4a5051',
      },
      Text: {
        WebPoweredBy1: 'Powered by',
        WebPoweredBy2: 'BookMeBob',
      },
      Urls: {
        // Icon: 'https://assets.bookmebob.com/images/avatars/bob.png',
        Icon: `${imageDomain}/images/avatars/bob.png`,
        CrossIcon: 'https://webchat.bookmebob.com/res/close_cross.png',
        MinimiseIcon: 'https://webchat.bookmebob.com/res/minus.png',
        WebCookies: 'https://www.bookmebob.com/cookies',
        WebPoweredBy: 'https://www.bookmebob.com',
      },
    },
  });

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
      })
      .catch((err) => console.error(err));
  }, []);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleCheckChange = (e) => {
    if (e.target.checked) {
      arr[e.target.id] = e.target.value;
    }
    if (!e.target.checked) {
      arr[e.target.id] = undefined;
    }
    const filterList = arr.filter((elem) => elem !== undefined || null);
    setInputData({ ...inputData, Properties: filterList });
  };

  const handleSave = async () => {
    /**  When creating a response for a integration, don't need pass a property id*/
    Axios.all([
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: GreetingCode1,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: ['Hi, how can I help?'],
          Overrides: {},
        },
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: EyeCatcherCode1,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: ['Hi, how can I help?'],
          Overrides: {},
        },
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: GreetingCode2,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: [
            'Hi, I can help you with bookings or answer any questions you may have.',
          ],
          Overrides: {},
        },
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_A_Message,
        data: {
          GroupId: getGroupID(),
          Code: EyeCatcherCode2,
          Language: 'en-US',
          Channel: 'VoucherWebsite',
          Default: [
            'Hi, I can help you with bookings or answer any questions you may have.',
          ],
          Overrides: {},
        },
        postAPI_Create_VocuherWebiste_Ingetration,
      }),
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_VocuherWebiste_Ingetration,
        data: inputData,
      }),
    ]).then(() =>
      setTimeout(() => {
        LoadIntegrations();
      }, 300)
    );
    toggle();
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>Add Voucher Integration</h6>
                <Separator className="mb-3" />

                <Form>
                  <FormGroup>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                    />
                  </FormGroup>
                  <FormGroup>
                    <div style={{ padding: '0 20%' }}>
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="checkbox"
                            id={index}
                            label={p.name}
                            value={p.id}
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  <Button color="primary" size="xs" onClick={handleSave}>
                    Create New Voucher Integration
                  </Button>
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
